<div *ngIf="showBanner" class="gssp-banner gssp-{{messageType}}-banner py-2">
  <mat-icon *ngIf="messageType==='success'" class="checkIcon">check_circle_outline</mat-icon>
  <mat-icon *ngIf="messageType==='warning'" class="infoIcon">info_outline</mat-icon>
  <adp-label [labelKey]="labelKey" *ngIf="labelKey" class="bannerText"></adp-label>
  <div [innerHTML]="innerHTML" *ngIf="innerHTML" class="bannerText"></div>
  <mat-icon (click)="close()" class="closeIcon">clear</mat-icon>
</div>
